import { createApp } from 'vue'
import router from './router'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import store from './store'
import '/public/icon/icon.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'



const app = createApp(App).use(router).use(ElementPlus).use(store)
store.commit("getadmindata");
app.mount('#app')


for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.config.silent = true;
